import React, {useMemo} from 'react';
import ReactApexChart from 'react-apexcharts';
import PropTypes from 'prop-types';
import CSVLink from "../../../useHook/useCSV";

function ColumnChart(props) {
    const {downloadCSV, options, title, description, data} = props;

    const colorList = useMemo(() => {
        const colors = [];
        data.forEach(item => {
            colors.push(item.color);
        })
        return colors;
    }, [data]);

    const memoList = useMemo(() => {
        return data.map(item => {
            const list = Object.values(item.data);
            const name = (options && options.item_type === 'team_id' ? item.team_name : item.player_name) || '';
            return {
                name,
                data: list,
            };
        })
    }, [data, options]);

    const memoHeaders = useMemo(() => {
        let list = [];
        if(data.length > 0) {
            list = Object.keys(data[0].data);
        }
        return list;
    }, [data]);

    const dataCSV = useMemo(() => {
        if(data.length === 0) return [];
        const list = [];
        const listTitle = [''];
        let keys = [];
        let values = [];

        data.forEach((item) => {
            values.push(Object.values(item.data));
            keys = Object.keys(item.data);
            const name = (options && options.item_type === 'team_id' ? item.team_name : item.player_name) || '';
            if(!name) return;
            listTitle.push(name);
        });

        keys.forEach((key, idx) => {
            if(data.length > 1) {
                list.push([key, values[0][idx], values[1][idx]]);
                return;
            }
            list.push([key, values[0][idx]]);
        });

        const listSubTitle = [options.x, options.y, listTitle.length > 2 ? options.y : ''];

        return [
            [title],
            listTitle,
            listSubTitle,
            ...list,
            [description],
        ];
    }, [data, options, title, description]);
    return <>
        <ReactApexChart options={{
        chart: {
            type: 'bar',
            zoom: {
                enabled: false
            },
            animations: {
                enabled: false
            },
            toolbar: {
                show: false,
            },
            offsetX: -5,
        },
        colors: colorList,
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
            },
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        title: {
            enabled: false
        },
        grid: {
            row: {
                colors: ['transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: memoHeaders,
            labels: {
                style: {
                    colors: '#AAAAAA',
                },
            },
            title: {
                text: options.x,
                style: {
                    color: '#3c4144',
                    fontSize: 16,
                    fontWeight: '400'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#AAAAAA',
                },
            },
            title: {
                text: options.y,
                style: {
                    color: '#3c4144',
                    fontSize: 16,
                    fontWeight: '400'
                }
            }
        },
        fill: {
            opacity: 1
        },
        legend: {
            show: false,
        }
    }} series={memoList} type="bar" height={'100%'}/>
        <CSVLink data={dataCSV} autoDownload={downloadCSV} filename={'player-topic-column-chart.csv'} />
    </>
}

ColumnChart.propTypes = {
    headers: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
};

export default ColumnChart;
